import { Connections } from '../connections.class';

export type DeleteConnectionCfnParams = {
	panelId: string;
	targetIslandId: string;
};

export const deleteConnectionCfn = (connections: Connections, params: DeleteConnectionCfnParams): boolean | null => {
	const { panelId, targetIslandId } = params;
	let index: number | null = null;
	const prevLength = connections.children.length;

	// find the matching index
	const connection = connections.children.find((c, i) => {
		if (c.sourcePanelId === panelId && c.targetIslandId === targetIslandId) {
			index = i;
			return true;
		}
		return false;
	}) ?? null;
	const targetConnection = connection?.targetConnection ?? null;

	// console.log('targetConnection', panelId, targetIslandId, targetConnection, connection);
	// return null if no match was found
	if (index === null) return null;

	// remove the entry
	connections.children.splice(index, 1);

	// remove cooresponding connection
	targetConnection?.sourceIsland?.connections
		?.deleteConnection(targetConnection.sourcePanelId, targetConnection.targetIslandId);

	// if sucessful the current legth with be a shy of the previous length
	return connections.children.length + 1 === prevLength;
}
